import { APP } from '@/constants/app.constant';
import { CustomPermission } from '@/models/custom-permission.model';
import { CustomResponse } from '@/models/custom-response.model';
import { CustomRole } from '@/models/custom-role.model';
import axios from 'axios';

export const PermissionService = {

    listPermissions,
    listRoles,
};

function listPermissions(): Promise<CustomResponse<CustomPermission[]>> {
    return axios.get(`${APP.API_URL}/permissions`)
        .then(handleResponse)
        .then((response: CustomResponse<CustomPermission[]>) => {
            response.data = response.data.map((item: any) => new CustomPermission(item));
            return response;
        })
        .catch((error) => {
            throw error.response && error.response.data;
        });
}

function listRoles(): Promise<CustomResponse<CustomRole[]>> {
    return axios.get(`${APP.API_URL}/roles`)
        .then(handleResponse)
        .then((response: CustomResponse<CustomRole[]>) => {
            response.data = response.data.map((item: any) => new CustomRole(item));
            return response;
        })
        .catch((error) => {
            throw error.response && error.response.data;
        });
}

function handleResponse(response: any): CustomResponse<any> {
    return response.data;
}
